import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01a002fc")

_pushScopeId("data-v-01a002fc")
const _hoisted_1 = {
  ref: "wrapper",
  class: "stream-outer"
}
const _hoisted_2 = { class: "stream-inner" }
const _hoisted_3 = { class: "time-group-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")
  const _component_messages_stream_message = _resolveComponent("messages-stream-message")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ion_list, {
        lines: "none",
        class: "messages"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messageGroups, (group) => {
            return (_openBlock(), _createBlock(_Fragment, {
              key: group.time
            }, [
              (_ctx.showDates)
                ? (_openBlock(), _createBlock(_component_ion_item_divider, {
                    key: 0,
                    class: "time-group",
                    color: "white"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("strong", null, _toDisplayString(group.formattedDate), 1),
                        _createTextVNode(" " + _toDisplayString(group.formattedTime), 1 /* TEXT */)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.messages, (message) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  key: message.id,
                  class: message.attributes.direction
                }, {
                  default: _withId(() => [
                    _createVNode(_component_messages_stream_message, {
                      message: message,
                      name: 
                                    message.attributes.direction == 'out'
                                        ? _ctx.inName
                                        : _ctx.outName
                                ,
                      "show-name": 
                                    _ctx.showStoreName ||
                                        message.attributes.direction == 'in'
                                
                    }, null, 8, ["message", "name", "show-name"])
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1
      })
    ])
  ], 512))
})